<template>
  <tr>
    <td>
      <div class="acciones">
        <!-- Botón editar codigo -->
        <button
          type="button"
          class="btn btn-warning"
          @click="clickEditarCodigo()"
        >
          <blaise-icon icon="EDITAR" />
        </button>
        <!-- Botón eliminar codigo -->
        <button
          type="button"
          class="btn btn-danger"
          @click="clickEliminarCodigo()"
        >
          <blaise-icon icon="ELIMINAR" />
        </button>
      </div>
    </td>
    <th scope="row">{{ valor.codigo }}</th>
    <td>{{ valor.fechaInicio }}</td>
    <td>{{ valor.fechaVencimiento }}</td>
    <td>{{ valor.utilizado ? "Si" : "" }}</td>
    <td>{{ valor.dniAfiliado }}</td>
    <td>{{ valor.companiaNombre }}</td>
  </tr>
</template>
<script>
export default {
  components: {},
  props: {
    valor: Object,
  },
  computed: {},
  methods: {
    clickEditarCodigo() {
      this.$emit("editar");
    },
    clickEliminarCodigo() {
      this.$emit("eliminar");
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
